import React from "react";
import { Img } from "../../Img";
export const TrustPilotEvaluation = ({ excellentLabel, rating, starsImage, trustpilotImage }) => (React.createElement("div", { className: "trustPilotEvaluation" },
    React.createElement("h5", { className: "trustPilotEvaluation__excellentLabel" }, excellentLabel),
    React.createElement(Img, { className: "trustPilotEvaluation__starsImage", src: starsImage, alt: "starsImage" }),
    React.createElement("p", { className: "trustPilotEvaluation__rating" }, rating),
    React.createElement(Img, { className: "trustPilotEvaluation__trustpilotImage", src: trustpilotImage, alt: "trustpilotImage" })));
